export const NAME = 'login';

// Actions Types pour logger le user

export const RESET_LOGIN_FORM = 'RESET_LOGIN_FORM';

export const REQUEST_LOGIN = 'REQUEST_LOGIN';
export const SUCCESS_LOGIN = 'SUCCESS_LOGIN';
export const FAILURE_LOGIN = 'FAILURE_LOGIN';

// Succès de l'étape Darty (/darty/login) : le back renvoie une URL ?tk=xxx,
// l'authentification réelle (token + user) arrive ensuite via SUCCESS_LOGIN (/auth/login)
export const SUCCESS_DARTY_LOGIN = 'SUCCESS_DARTY_LOGIN';



// WEBPACK FOOTER //
// ./src/services/authentication/login/constants.js